module["exports"] = [
  "#####"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/uk/address/postcode.js
// module id = 1325
// module chunks = 0